import { render, staticRenderFns } from "./HappyKidsInsurerDetail.vue?vue&type=template&id=00a37d21&scoped=true"
import script from "./HappyKidsInsurerDetail.vue?vue&type=script&lang=js"
export * from "./HappyKidsInsurerDetail.vue?vue&type=script&lang=js"
import style0 from "./HappyKidsInsurerDetail.vue?vue&type=style&index=0&id=00a37d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a37d21",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HappyKidsInsurerHeadSection: require('/app/components/happy-kids/insurer/HappyKidsInsurerHeadSection.vue').default,HappyKidsProductCarousel: require('/app/components/happy-kids/HappyKidsProductCarousel.vue').default,HappyKidsInsurerCards: require('/app/components/happy-kids/insurer/HappyKidsInsurerCards.vue').default,ButtonComponent: require('/app/components/common/ButtonComponent.vue').default,HappyKidsInsurerTextAndImage: require('/app/components/happy-kids/insurer/HappyKidsInsurerTextAndImage.vue').default,HappyKidsInsurerSideBySideSection: require('/app/components/happy-kids/insurer/HappyKidsInsurerSideBySideSection.vue').default,FiveStarVideo: require('/app/components/5star-products/FiveStarVideo.vue').default,HappyKidsCrossSellingBanner: require('/app/components/happy-kids/HappyKidsCrossSellingBanner.vue').default,HappyKidsDocumentUpload: require('/app/components/happy-kids/HappyKidsDocumentUpload.vue').default,HappyKKidsDisclaimer: require('/app/components/happy-kids/HappyKKidsDisclaimer.vue').default})
